/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class DialogService {
   $modalStack: any
   $uibModal: any
   isClosing: any
   isDisplayed: any
   modalInstance: any
   viewState: ViewStateService
   constructor($uibModal: any, $modalStack: any, viewState: ViewStateService){
      this.displayDialog = this.displayDialog.bind(this)
      this.displayModalDialog = this.displayModalDialog.bind(this)
      this.closeModalDialog = this.closeModalDialog.bind(this)
      this.$uibModal = $uibModal
      this.$modalStack = $modalStack
      this.isDisplayed = false
      this.isClosing = false
      this.modalInstance = null
      this.viewState = viewState
   }

   displayDialog(type: any, scope: any, cb=function(modal: any) {}) {
      if (this.isDisplayed) {
         if (this.modalInstance) { return this.modalInstance.result }
         // stale state: isDisplayed is true but no modal instance — fall through and re-open
      }
      this.isDisplayed = true
      this.isClosing = false
      if (!scope.params) { scope.params = {} }
      const modalInstance = this.$uibModal.open({
         templateUrl: '/assets/modals/' + type + '.html',
         controller: 'ModalInstanceCtrl',
         scope,
         backdrop: true,
         keyboard: true
      })
      this.modalInstance = modalInstance

      const promise = modalInstance.result.then((result: any) => {
         this.isDisplayed = false
         this.isClosing = true
         this.modalInstance = null
         return result
      }, (reason: any) => {
         this.isDisplayed = false
         this.isClosing = true
         this.modalInstance = null
         return Promise.reject(reason)
      })
      if (_.isFunction(cb)) { cb(modalInstance) }
      return promise
   }

   // ~params~
   // scope: current scope from where modal is called
   // controller: modal controller. i.e. 'QuickLookCtrl', 'AdvancedSearchModalCtrl'
   // type: modal dialog type. i.e. 'quick-look', 'advanced-search'... the css classes should have same name as suffix, like 'modal-quick-look'
   // templateUrl: html file of modal template. i.e. 'quickLook/quickLook.html' (without the 'assets' part)
   // backdrop: if background is disabled or not. true by default.
   // additionalClass: if needed, add a class name. Must include white space before the class name
   displayModalDialog(scope: any, controller: any, type: string, templateUrl: string, backdrop: boolean = true, additionalClass: string = '') {
      // open new modal
      let uibModalInstance
      this.viewState.subView = type
      return uibModalInstance = this.$uibModal.open({
         controller,
         controllerAs: 'ctrl',
         templateUrl: '/assets/' + templateUrl,
         openedClass: 'modal-open modal-' + type,
         windowClass: type + additionalClass,
         backdropClass: backdrop ? 'modal-backdrop' : undefined,
         animation: true,
         backdrop,
         scope
      })
   }
   closeModalDialog($event: any) { 
      $event?.preventDefault()
      return this.$modalStack.dismissAll('close modal')
   }
}
    

DialogService.$inject = ['$uibModal', '$uibModalStack', 'viewStateService']

angular.module('summonApp.services')
   .service('dialogService', DialogService)
